import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState, useRef } from 'react';
import { SubAccountCreationRequest } from './types';
import SubAccountCreationForm from './SubAccountCreationForm';
import SubAccountCreationReview from './SubAccountCreationReview';
import { PendingDataProvider } from '@/providers/PendingData.provider';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Title } = vp;

type FC = FunctionComponent;

const SubAccountCreationContainer: FC = () => {
  const reviewRef = useRef<HTMLDivElement>(null);
  const [isReview, setIsReview] = useState(false);
  const [subaccountRequest, setSubAccountRequest] = useState<SubAccountCreationRequest>({
    LegalBusinessName: '',
    OriginatorName: '',
    OriginatorShortName: '',
    EmailAddress: '',
    SendWelcomeEmail: true,
  });
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.Create' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const handlers = {
    onSubAccountCreation: (_values: SubAccountCreationRequest) => {
      setIsReview(true);
      setSubAccountRequest(_values);
    },
  };
  const onBack = () => {
    setIsReview(false);
  };

  useEffect(() => {
    if (isReview) {
      if (reviewRef !== null && reviewRef.current !== null) {
        reviewRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }, [isReview]);

  return (
    <div ref={reviewRef}>
      <Box mb="md" jc="sb" flx="col" gap="lg">
        <Box mb="lg">
          {isReview ? (
            <Box flx="col" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('Review.title')} />
            </Box>
          ) : (
            <Title title={t('title')} />
          )}
        </Box>
        <PendingDataProvider>
          <div>
            {!isReview && <SubAccountCreationForm handlers={handlers} defaultValues={subaccountRequest} />}
            {isReview && <SubAccountCreationReview values={subaccountRequest} />}
          </div>
        </PendingDataProvider>
      </Box>
    </div>
  );
};

export default SubAccountCreationContainer;
